import React from "react";
import cartBorder from "@assets/images/cartBorder.webp";

const CartSummarySkeleton: React.FC = () => {
  return (
    <div className="p-10 max-xl:p-4 max-lg:p-12 sticky top-0 max-md:p-0">
      <img
        className="absolute top-0 left-0 size-full max-md:hidden"
        src={cartBorder}
        alt=""
      />
      <div className="relative z-10 flex flex-col gap-4 max-sm:gap-3">
        <div className="flex items-center flex-wrap justify-between max-xl:flex-col max-lg:flex-row">
          <div className="h-6 w-44  skeleton !rounded-md"></div>
          <div className="flex items-center gap-1 duration-150 hover:scale-95 max-md:hidden">
            <div className="h-6 w-4 skeleton !rounded-md"></div>
            <div className="h-6 w-20 skeleton !rounded-md"></div>
          </div>
        </div>
        <div className="flex items-center justify-between max-md:hidden">
          <div className="h-4 w-20 skeleton !rounded-md"></div>
          <div className="h-4 w-10 skeleton !rounded-md"></div>
        </div>

        <div className="h-4 w-2/4 skeleton !rounded-md"></div>

        <div className="flex flex-col gap-5 mb-3 max-sm:mt-2 max-h-52 max-md:max-h-max overflow-auto">
          <div className="h-8 w-full skeleton !rounded-md"></div>
          <div className="h-8 w-full skeleton !rounded-md"></div>
        </div>
        <div className="flex flex-col gap-5 max-md:gap-3">
          <div className="flex items-center justify-between">
            <div className="h-8 w-2/4 skeleton !rounded-md"></div>

            <div className="h-5 w-8 skeleton !rounded-md"></div>
          </div>
          <div className="flex items-center justify-between">
            <div className="h-8 w-2/4 skeleton !rounded-md"></div>

            <div className="h-5 w-8 skeleton !rounded-md"></div>
          </div>
          <div className="flex items-center justify-between">
            <div className="h-8 w-2/4 skeleton !rounded-md"></div>

            <div className="h-5 w-8 skeleton !rounded-md"></div>
          </div>
        </div>
        <div className="flex items-center justify-between">
          <div className="h-8 w-2/4 skeleton !rounded-md"></div>

          <div className="h-5 w-8 skeleton !rounded-md"></div>
        </div>
        <div className="text-center px-4 py-0 flex flex-col items-center gap-2">
          <div className="h-8 w-full skeleton !rounded-md"></div>
          <div className="h-8 w-full skeleton !rounded-md"></div>
        </div>
      </div>
    </div>
  );
};

export default CartSummarySkeleton;
